// shared/subscription-defaults.js
// Single authoritative copy of the default tier limits and plan amounts.
// Imported by BOTH the server config (api/_lib/subscription-config.ts) and the
// client fallback (src/utils/subscriptionConfig.js) so the numbers cannot drift.
// Pure data — no environment access, plain JS so both esbuild (Vite) and the
// Vercel function bundler consume it without a transform step.
// The TierLimits type lives in api/_lib/subscription-config.ts.

// -1 = unlimited. maxFileSizeKB is in kilobytes. maxFinancialRecords applies
// to financial and policies (each counted per table).
export const DEFAULT_FREE_LIMITS = {
  maxCredentials: 2,
  maxCards: 2,
  maxNotes: 2,
  maxFinancialRecords: 2,
  maxDocuments: 0,
  maxNominees: 1,
  maxFileSizeKB: 500,
  documentsEnabled: false,
}

export const DEFAULT_PRO_LIMITS = {
  maxCredentials: -1,
  maxCards: -1,
  maxNotes: -1,
  maxFinancialRecords: -1,
  maxDocuments: -1,
  maxNominees: 4,
  maxFileSizeKB: 10240,
  documentsEnabled: true,
}

export const DEFAULT_PLAN_AMOUNTS = {
  pro_monthly: 999,
  pro_yearly: 9999,
}
